import { modelUtils } from '@pelicargo/utils';

import { TrpcOutputs } from '../config/trpc';

export type FlightSegment =
  | TrpcOutputs['getQuote']['flight_path'][0]
  | TrpcOutputs['getQuote']['quote_variants'][0]['flight_path'][0];

export type Provider = FlightSegment['provider'];
export type Airport = FlightSegment['origin_airport'] | FlightSegment['destination_airport'];

type UseFlightSegmentsHelper = {
  mostConstrainedLeg: FlightSegment;
  airports: Airport[];
  providers: Provider[];
};

export const useFlightSegmentsHelper = (flightSegments: FlightSegment[] = []): UseFlightSegmentsHelper => {
  const mostConstrainedLeg = modelUtils.flightSegments.mostConstrainingLeg(flightSegments);
  const airports = modelUtils.flightSegments.airports(flightSegments);
  const providers = modelUtils.flightSegments.providers(flightSegments);

  return {
    mostConstrainedLeg,
    providers,
    airports,
  };
};
